'use strict';

angular.module('loader', [])

.directive('loaderView', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var loadingLayer = $('<div class="loader"><div id="circleG"><div id="circleG_1" class="circleG"></div><div id="circleG_2" class="circleG"></div><div id="circleG_3" class="circleG"></div></div>').appendTo(element);
            $(element).addClass('loader-container');
			if(attrs.loaderFull == '')
			{
				loadingLayer.find('#circleG').addClass('full-width');
			}
            scope.$watch(attrs.loaderView, function (value) {
                loadingLayer.toggle(value);
            });
        }
    };
})

.directive('loaderViewCall', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var loadingLayer = $('<div class="loader-call"><div class="circleGCenter"><div id="circleGCall"><div id="circleG_1" class="circleG"></div><div id="circleG_2" class="circleG"></div><div id="circleG_3" class="circleG"></div><div id="msg"></div></div></div>').appendTo(element);
            $(element).addClass('loader-call-container');
            scope.$watch(attrs.loaderViewCall, function (value) {
                var msg = $("#divLoaderCall").attr('message');
                loadingLayer.find("#msg").text(msg);
                loadingLayer.toggle(value);
            });
        }
    };
})

.directive('fileSubmitLoader', function () {
    return {
        restrict: 'A',
        scope: true,
        controller: function($scope){
            $scope.loading = false;

            $scope.$on('dataSentStart', function(e, arg){
                $scope.loading = true;
            });

            $scope.$on('dataSentFinish', function(e, arg){
                $scope.loading = false;
            });
        },
        link: function (scope, element, attrs) {
            var loadingLayer = $('<div class="loader dark form"><div id="circleG"><div id="circleG_1" class="circleG"></div><div id="circleG_2" class="circleG"></div><div id="circleG_3" class="circleG"></div></div>').appendTo(element);
            loadingLayer.bind('click', function(e){
                e.stopPropagation();
            });

            if(attrs.fileSubmitLoader === 'white')
            {
                loadingLayer.removeClass('dark');
            }
            if('relative' in attrs)
            {
                element.css('position', 'relative');
            }

            scope.$watch('loading', function (value) {
                loadingLayer.toggle(value);
            });
        }
    };
});
